import { ModalPaddingSizes } from './Modal.types';

// TODO: We should not be defining arbitrary z-index values.
export const TEMP_ZINDEX = 2000;

export const MODAL_MIN_GUTTER = 16;

export const MODAL_CARD_MAX_WIDTH = 640;
export const MODAL_CLOSE_OFFSET = 16;

export const MODAL_BORDER_OFFSET = 2;
export const MODAL_BORDER_RADIUS = 20;

export const MODAL_LAYOUT_SPACING = 32;
export const MODAL_SECTION_SPACING = 16;

export const MODAL_PADDING_SIZES = {
    X: {
        [ModalPaddingSizes.Normal]: MODAL_LAYOUT_SPACING,
        [ModalPaddingSizes.Large]: MODAL_LAYOUT_SPACING * 2,
    },
    Y: {
        [ModalPaddingSizes.Normal]: MODAL_LAYOUT_SPACING,
        [ModalPaddingSizes.Large]: MODAL_LAYOUT_SPACING * 2,
    },
};
